import moment from 'moment';

export const setCookie = (name: string, value: number | string | boolean, path: string = '/') => {
  const expires = moment().add(20, 'year').toDate();
  document.cookie = `${name}=${value};path=${path};expires=${expires}`;
};

export const hasCookie = (name: string) => {
  return document.cookie.indexOf(`${name}=`) > -1;
};

export const getCookie = (name: string) => {
  const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
  return match ? match[2] : null;
};

export const incrementViewCount = (name: string) => {
  const currentCount = parseInt(getCookie(name) || '0', 10);
  const newCount = currentCount + 1;
  setCookie(name, newCount);
  return newCount;
};

export const removeCookie = (name: string) => {
  const expires = moment().subtract(20, 'year').toDate();
  document.cookie = `${name}=;path=/;expires=${expires}`;
};
